import createDebug from 'debug';
import React from 'react';

import { DebugKey } from '@swf/core/enums';

interface ErrorBoundaryState {
  error?: Error;
  info?: React.ErrorInfo;
}

interface Props {
  fallback?: React.ReactNode;
}

const debug = createDebug(DebugKey.Error);
// eslint-disable-next-line no-console
debug.log = console.error.bind(console);

export default class ErrorBoundary extends React.PureComponent<Props, ErrorBoundaryState> {
  state: ErrorBoundaryState = {};

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ error, info });
    debug(`caught rendering\n%s%s`, error.toString(), info.componentStack);
  }

  render() {
    const { error, info } = this.state;
    const { children, fallback } = this.props;

    if (!error) {
      return children;
    }
    if (process.env.NODE_ENV !== 'production') {
      const childProps: string[] = [];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      React.Children.forEach<any>(children, (child: React.ReactElement<any>) => {
        if (child.props) {
          try {
            childProps.push(JSON.stringify(child.props));
          } catch (err) {
            // do nothing;
          }
        }
      });
      return (
        <div
          style={{
            background: 'hsl(0, 100%, 97%)',
            padding: '15px',
            border: '1px solid hsl(0, 100%, 92%)',
            color: 'red',
            fontFamily: 'Menlo, monospace',
            fontSize: '11px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap'
          }}
        >
          {error.toString()}
          {!info ? null : info.componentStack}
          {`\n\nChild Props:\n    ${childProps.join('\n    ')}`}
        </div>
      );
    } else {
      return fallback || null;
    }
  }
}
